module.exports = __webpack_public_path__ + "media/images/flags/4x3/atf-a0a0fd598248bc52ea315cad1e7c3677.svg";